import { supabase } from './supabase';

const OK_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'];
const MAX_BYTES = 5 * 1024 * 1024;

// Sube un certificado a la carpeta privada <organización>/<empleado>/ y devuelve la ruta
export const uploadCertificate = async (orgId, employeeId, file) => {
  if (!file) throw new Error('Elegí un archivo');
  if (!OK_TYPES.includes(file.type)) throw new Error('El certificado tiene que ser PDF, PNG, JPG o WEBP');
  if (file.size > MAX_BYTES) throw new Error('El archivo pesa más de 5 MB');
  const ext = file.type === 'application/pdf' ? 'pdf' : file.type.split('/')[1].replace('jpeg', 'jpg');
  const id = (crypto.randomUUID?.() || String(Date.now()));
  const path = `${orgId}/${employeeId}/${id}.${ext}`;
  const { error } = await supabase.storage.from('certificates').upload(path, file, { contentType: file.type, upsert: false });
  if (error) throw new Error(error.message || 'No se pudo subir el archivo');
  return path;
};

// Link temporal (5 minutos) para ver un certificado
export const certificateUrl = async (path) => {
  const { data, error } = await supabase.storage.from('certificates').createSignedUrl(path, 300);
  if (error) throw new Error('No se pudo abrir el certificado');
  return data.signedUrl;
};

export const requestJustification = async (date, reason, path) => {
  const { data, error } = await supabase.rpc('request_justification', { p_date: date, p_reason: reason, p_path: path || null });
  if (error) throw new Error(error.message);
  return data;
};
export const reviewJustification = async (id, approve, note) => {
  const { error } = await supabase.rpc('review_justification', { p_id: id, p_approve: approve, p_note: note || null });
  if (error) throw new Error(error.message);
};
export const myJustifications = async (employeeId) => {
  const { data, error } = await supabase.from('justification_requests').select('*').eq('employee_id', employeeId).order('created_at', { ascending: false }).limit(30);
  if (error) throw error;
  return data || [];
};
export const listJustifications = async () => {
  const { data, error } = await supabase.from('justification_requests')
    .select('*, profiles!justification_requests_employee_id_fkey(name,avatar)').order('created_at', { ascending: false }).limit(300);
  if (error) throw error;
  return data || [];
};
export const markGuideSeen = async (version) => {
  const { error } = await supabase.rpc('mark_guide_seen', { p_version: version });
  if (error) throw new Error(error.message);
};
export const adminSetEmployeeJustifiedPct = async (employeeId, pct) => {
  const { error } = await supabase.rpc('admin_set_employee_justified_pct', { p_employee: employeeId, p_pct: pct === '' || pct == null ? null : Number(pct) });
  if (error) throw new Error(error.message);
};
